module.exports = __webpack_public_path__ + "img/chat.ee284f96.svg";